import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { format, parseISO } from 'date-fns';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@mui/material';
import { MdDelete } from "react-icons/md";
import { FaEdit, FaRegEye } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { FiAlertTriangle } from "react-icons/fi";

export default function GuruList() {

    const lottiee = require('../images/lottiee.json');
    const loading = require('../images/loading.json');

    const [show, setShow] = useState(false);
    const [smShow, setSmShow] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);

    const handleShow2 = (MuniTeamInfoData) => {
        setmuniData(MuniTeamInfoData)
        setShow2(true)
    };

    const [loader, setloader] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [sadvikData, setsadvikData] = useState([]);
    const [muniData, setmuniData] = useState([]);
    const [FormData, setFormData] = useState([])

    const [MS_MuniName, setMS_MuniName] = useState('');
    const [MS_SangName, setMS_SangName] = useState('');
    const [MS_SangDescription, setMS_SangDescription] = useState('');
    const [MS_SangContactNumber, setMS_SangContactNumber] = useState('');
    const [MS_SangWhatsappNumber, setMS_SangWhatsappNumber] = useState('');
    const [MS_SangEmailID, setMS_SangEmailID] = useState('');
    const [Name, setName] = useState('');
    const [MobileNo, setMobileNo] = useState('');
    const [Designation, setDesignation] = useState('');
    const [updateSadvik, setupdateSadvik] = useState({});

    const filteredData = sadvikData.filter((item) => {
        return (
            item.MS_MuniName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.MS_SangName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.MS_SangContactNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.MS_SangWhatsappNumber.toLowerCase().includes(searchQuery.toLowerCase())
        );
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const sadvikList = () => {
        setloader(true)
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        fetch("https://api.padampura.com/MuniSadviksList", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result);
                    setsadvikData(result.data.MunisSadviksData);
                    setloader(false);
                } else {
                    setloader(false)
                }
            })
            .catch((error) => console.error(error))
            .finally(() => setloader(false))
    }

    const handleAddMoreDetail = () => {
        const newData = {
            Name,
            MobileNo,
            Designation
        };
        setFormData(prevData => [...prevData, newData]);
        setName('');
        setMobileNo('');
        setDesignation('');
    };

    const handleDelete = (index) => {
        setFormData(prevData => prevData.filter((item, i) => i !== index));
    };

    const handleClear = () => {
        setMS_MuniName('');
        setMS_SangName('');
        setMS_SangDescription('');
        setMS_SangContactNumber('');
        setMS_SangWhatsappNumber('');
        setMS_SangEmailID('');
        setFormData([]);
    }

    const handleReservContNo = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, '');
        const limitedValue = numericValue.slice(0, 10);
        setMS_SangContactNumber(limitedValue);
    };

    const handleReservWhatsApp = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, '');
        const limitedValue = numericValue.slice(0, 10);
        setMS_SangWhatsappNumber(limitedValue);
    };

    const handleReservMobileNo = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, '');
        const limitedValue = numericValue.slice(0, 10);
        setMobileNo(limitedValue);
    };

    const insertMuni = () => {
        if (!MS_MuniName) {
            alert("Please enter Name");
            return;
        }
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "MS_MuniName": MS_MuniName,
            "MS_SangName": MS_SangName,
            "MS_SangDescription": MS_SangDescription,
            "MS_SangContactNumber": MS_SangContactNumber,
            "MS_SangWhatsappNumber": MS_SangWhatsappNumber,
            "MS_SangEmailID": MS_SangEmailID,
            "MuniTeamInfo": FormData
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://api.padampura.com/MuniSadviks_Insert", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result)
                    alert('Insert Successfully');
                    sadvikList();
                } else (
                    alert('Try Again...!!')
                )
            })
            .catch((error) => console.error(error));
    }

    const handleChangeUpdtSadvi = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setupdateSadvik({
                ...updateSadvik,
                [name]: checked,
            });
        } else {
            if (name === "MS_SangContactNumber") {
                const inputValue = value;
                if (/^\d{0,10}$/.test(inputValue) || inputValue === "") {
                    setupdateSadvik({
                        ...updateSadvik,
                        [name]: inputValue,
                    });
                } else {
                    alert("Enter only numbers");
                }
            } else if (name === "MS_SangWhatsappNumber") {
                const inputValue = value;
                if (/^\d{0,10}$/.test(inputValue) || inputValue === "") {
                    setupdateSadvik({
                        ...updateSadvik,
                        [name]: inputValue,
                    });
                } else {
                    alert("Enter only numbers");
                }
            } else {
                setupdateSadvik({
                    ...updateSadvik,
                    [name]: value,
                });
            }
        }
    };

    const [newMuni, setNewMuni] = useState({ Name: '', MobileNo: '', Designation: '' });

    const handleAddNewMuni = () => {
        setupdateSadvik({
            ...updateSadvik,
            MuniTeamInfo: [...updateSadvik.MuniTeamInfo, newMuni],
        });
        setNewMuni({ Name: '', MobileNo: '', Designation: '' });
    };

    const handleChangeUpdtMuniTeamInfo = (index, field, value) => {
        const newData = [...updateSadvik.MuniTeamInfo];
        newData[index] = {
            ...newData[index],
            [field]: value,
        };
        setupdateSadvik({
            ...updateSadvik,
            MuniTeamInfo: newData,
        });
    };

    const editSadvi = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            ...updateSadvik,
            "MuniTeamInfo": updateSadvik.MuniTeamInfo,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch(`https://api.padampura.com/MuniSadviks_Update?MainID=${updateSadvik.MS_ID}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result);
                    sadvikList();
                }
            })
            .catch((error) => console.error(error));
    }

    const getDataId = (x) => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        fetch(`https://api.padampura.com/MuniSadviks_Data_ByID?MainID=${x}`, requestOptions)
          .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result)
                    setupdateSadvik(result.data)
                }
            })
            .catch((error) => console.error(error));
    }

    const deleteMuni =()=>{
        const requestOptions = {
            method: "DELETE",
            redirect: "follow"
          };
          
          fetch(`https://api.padampura.com/MuniSadviks_Delete?MainID=${updateSadvik.MS_ID}`, requestOptions)
           .then((response) => response.json())
            .then((result) => {
                    if(result.status === true){
                        // console.log(result)
                        alert('Delete Successfully')
                        sadvikList();
                    }else{
                        alert('Something went wrong')
                    }
            })
            .catch((error) => console.error(error));
    }

    useEffect(() => {
        sadvikList();
    }, [])

    return (
        <>
        
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-2 side'>
                        <Sidebar />
                    </div>
                    <div className='col-10 side2'>
                        <Header />
                        <div className='scroll-box'>
                            <div className="container-fluid">
                                <div className='row d-flex justify-content-between mt-2'>
                                    <div className='col-4' style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "1.2em", }} >Muni's</div>
                                    <div className='col-4'>
                                        <TextField
                                            label="Search..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            sx={{ mb: 0 }}
                                        />
                                    </div>
                                    <div onClick={handleShow} className='col-2 d-flex justify-content-center align-items-center p-1 rounded-1' style={{ backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>+ Add</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12 m-auto">
                                        <div className='card-list-box-sr card p-2 border-0'>
                                            <div className="table-responsive">
                                                <Paper sx={{ width: '100%' }}>
                                                    <TableContainer sx={{ mt: -1 }}>
                                                        <Table stickyHeader aria-label="sticky table" size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Sang Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Description</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Number</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>WhatsApp No.</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>View</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    loader ? (
                                                                        <TableRow>
                                                                            <TableCell colSpan={7} align="center">
                                                                                <div style={{ fontFamily: "Poppins", fontSize: 16 }} >Loading...</div>
                                                                                <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={loading}
                                                                                    style={{ height: '200px', width: '200px' }}
                                                                                >
                                                                                    <Controls visible={false} buttons={['play', 'repeat',]} />
                                                                                </Player>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ) : filteredData.length === 0 ? (
                                                                        <TableRow>
                                                                            <TableCell colSpan={7} align="center">
                                                                                <div style={{ fontFamily: "Poppins", fontSize: 16, color: 'red' }} >Data Not Present...</div>
                                                                                <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={lottiee}
                                                                                    style={{ height: '100px', width: '100px' }}
                                                                                >
                                                                                    <Controls visible={false} buttons={['play', 'repeat',]} />
                                                                                </Player>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ) : (
                                                                        filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                                                            <TableRow key={index}>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.MS_MuniName}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.MS_SangName}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.MS_SangDescription}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.MS_SangContactNumber}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.MS_SangWhatsappNumber}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                    <FaRegEye onClick={() => { handleShow2(); getDataId(item.MS_ID) }} style={{ cursor: "pointer", color: "#566573" }} />
                                                                                </TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", }}>
                                                                                    <div className='d-flex justify-content-center' style={{ width: 50, }}>
                                                                                        <MdDelete onClick={()=> {setSmShow(true);getDataId(item.MS_ID)}} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                                                    </div>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))
                                                                    )
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 20]}
                                                        component="div"
                                                        count={sadvikData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                                <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Add Muni's</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Name</div>
                                                                    <input className='sercc-inpt p-1' placeholder="Name" value={MS_MuniName} onChange={(e) => setMS_MuniName(e.target.value)} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Sang Name</div>
                                                                    <input className='sercc-inpt p-1' placeholder="sang Name" value={MS_SangName} onChange={(e) => setMS_SangName(e.target.value)} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Description</div>
                                                                    <input className='sercc-inpt p-1' placeholder="Description" value={MS_SangDescription} onChange={(e) => setMS_SangDescription(e.target.value)} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Mobile No.</div>
                                                                    <input className='sercc-inpt p-1' placeholder="Mobile No" value={MS_SangContactNumber} onChange={handleReservContNo} maxLength={10} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>WhatsApp No.</div>
                                                                    <input className='sercc-inpt p-1' placeholder="WhatsApp No" value={MS_SangWhatsappNumber} onChange={handleReservWhatsApp} maxLength={10} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Email</div>
                                                                    <input className='sercc-inpt p-1' placeholder="Email" value={MS_SangEmailID} onChange={(e) => setMS_SangEmailID(e.target.value)} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Name</div>
                                                                    <input className='sercc-inpt p-1' placeholder="Name" value={Name} onChange={(e) => setName(e.target.value)} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Mobile No.</div>
                                                                    <input className='sercc-inpt p-1' placeholder="Mobile No" value={MobileNo} onChange={handleReservMobileNo} maxLength={10} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Designation</div>
                                                                    <input className='sercc-inpt p-1' placeholder="Designation" value={Designation} onChange={(e) => setDesignation(e.target.value)} autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                            </div>
                                                            <Paper className='mt-3' sx={{ width: '100%' }}>
                                                                <TableContainer sx={{ mt: -1 }}>
                                                                    <Table stickyHeader aria-label="sticky table" size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Name</TableCell>
                                                                                <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Mobile No</TableCell>
                                                                                <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Description</TableCell>
                                                                                <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Action</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {
                                                                                FormData.map((item, index) => {
                                                                                    return (
                                                                                        <TableRow key={index}>
                                                                                            <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.Name}</TableCell>
                                                                                            <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.MobileNo}</TableCell>
                                                                                            <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.Designation}</TableCell>
                                                                                            <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                                <div className='d-flex justify-content-center' style={{ width: 50, }}>
                                                                                                    <MdDelete onClick={() => { handleDelete(index) }} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                                                                </div>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Paper>
                                                            <div className='row mt-2'>
                                                                <div className='col-6 m-auto'>
                                                                    <div className='d-flex justify-content-between' >
                                                                        <div onClick={handleAddMoreDetail} className='d-flex justify-content-center align-items-center p-1 rounded-1 me-5' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Add More</div>
                                                                        <div onClick={() => { handleClose(); insertMuni(); handleClear() }} className='ms-5 d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Save</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                                <Modal show={show2} onHide={handleClose2} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Muni's </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    <div className='card-list-box-sr card p-2 border-0'>
                                                                        <div className="table-responsive">
                                                                            <div className='row'>
                                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Name</div>
                                                                                    <input className='sercc-inpt p-1' name='MS_MuniName' value={updateSadvik.MS_MuniName} placeholder="Name" onChange={handleChangeUpdtSadvi} autoFocus required style={{ width: "100%" }} />
                                                                                </div>
                                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Sang Name</div>
                                                                                    <input className='sercc-inpt p-1' name='MS_SangName' value={updateSadvik.MS_SangName} placeholder="sang Name" onChange={handleChangeUpdtSadvi} autoFocus required style={{ width: "100%" }} />
                                                                                </div>
                                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Description</div>
                                                                                    <input className='sercc-inpt p-1' name='MS_SangDescription' value={updateSadvik.MS_SangDescription} placeholder="Description" onChange={handleChangeUpdtSadvi} autoFocus required style={{ width: "100%" }} />
                                                                                </div>
                                                                            </div>
                                                                            <div className='row'>
                                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Mobile No.</div>
                                                                                    <input className='sercc-inpt p-1' name='MS_SangContactNumber' value={updateSadvik.MS_SangContactNumber} onChange={handleChangeUpdtSadvi} type='tel' pattern="[0-9]{10}" maxLength={10} placeholder="Mobile No" autoFocus required style={{ width: "100%" }} />
                                                                                </div>
                                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Whatsapp No.</div>
                                                                                    <input className='sercc-inpt p-1' name='MS_SangWhatsappNumber' value={updateSadvik.MS_SangWhatsappNumber} onChange={handleChangeUpdtSadvi} type='tel' pattern="[0-9]{10}" maxLength={10} placeholder="Whatsapp No" autoFocus required style={{ width: "100%" }} />
                                                                                </div>
                                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Email</div>
                                                                                    <input className='sercc-inpt p-1' name='MS_SangEmailID' value={updateSadvik.MS_SangEmailID} onChange={handleChangeUpdtSadvi} placeholder="Email" autoFocus required style={{ width: "100%" }} />
                                                                                </div>
                                                                            </div>
                                                                            <div className="table-responsive mt-3">
                                                                                <Paper sx={{ width: '100%' }}>
                                                                                    <TableContainer sx={{ mt: -1 }}>
                                                                                        <Table stickyHeader aria-label="sticky table" size="small">
                                                                                            <TableHead>
                                                                                                <TableRow>
                                                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Name</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Number</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Description</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}></TableCell>
                                                                                                </TableRow>
                                                                                            </TableHead>
                                                                                            <TableBody>
                                                                                                {
                                                                                                    Array.isArray(updateSadvik.MuniTeamInfo) && updateSadvik.MuniTeamInfo.map((item, index) => {
                                                                                                        return (
                                                                                                            <TableRow key={index}>
                                                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                                                    <input type="text" name='Name' value={item.Name} onChange={(e) => handleChangeUpdtMuniTeamInfo(index, "Name", e.target.value)} className='sercc-inpt p-1' style={{ width: "100%" }} />
                                                                                                                </TableCell>
                                                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                                                    <input type="tel" pattern="[0-9]*" name='MobileNo' value={item.MobileNo} onChange={(e) => {
                                                                                                                      const inputValue = e.target.value;
                                                                                                                        if (/^\d{0,10}$/.test(inputValue) || inputValue === "") {
                                                                                                                            handleChangeUpdtMuniTeamInfo(index, "MobileNo", inputValue);
                                                                                                                        } else {
                                                                                                                            alert("Enter 10 digit numbers");
                                                                                                                        }
                                                                                                                    }} className='sercc-inpt p-1' style={{ width: "100%" }} />
                                                                                                                </TableCell>
                                                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                                                    <input type="text" name='Designation' value={item.Designation} onChange={(e) => handleChangeUpdtMuniTeamInfo(index, "Designation", e.target.value)} className='sercc-inpt p-1' style={{ width: "100%" }} />
                                                                                                                </TableCell>
                                                                                                            </TableRow>
                                                                                                        );
                                                                                                    })
                                                                                                }
                                                                                                <TableRow>
                                                                                                    <TableCell>
                                                                                                        <input type="text" name='Name' value={newMuni.Name} onChange={(e) => setNewMuni({ ...newMuni, Name: e.target.value })} placeholder='Name' className='sercc-inpt p-1' style={{ width: "100%" }} />
                                                                                                    </TableCell>
                                                                                                    <TableCell>
                                                                                                        <input type="text" name='MobileNo' value={newMuni.MobileNo}
                                                                                                            onChange={(e) => {
                                                                                                                const inputVal = e.target.value;
                                                                                                                if (/^\d{0,10}$/.test(inputVal)) {
                                                                                                                    setNewMuni({ ...newMuni, MobileNo: inputVal });
                                                                                                                } else {
                                                                                                                    alert("Mobile number must be number and 10 digits");
                                                                                                                }
                                                                                                            }} placeholder='Mobile No' className='sercc-inpt p-1' style={{ width: "100%" }} />
                                                                                                    </TableCell>
                                                                                                    <TableCell>
                                                                                                        <input type="text" name='Designation' value={newMuni.Designation} onChange={(e) => setNewMuni({ ...newMuni, Designation: e.target.value })} placeholder='Designation' className='sercc-inpt p-1' style={{ width: "100%" }} />
                                                                                                    </TableCell>
                                                                                                    <TableCell>
                                                                                                        <button onClick={handleAddNewMuni} className='d-flex justify-content-center align-items-center p-1 rounded-1 border-0' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>+ Add</button>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    </TableContainer>
                                                                                </Paper>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='row'>
                                                                    <div className='col-2 m-auto'>
                                                                        <div onClick={() => { handleClose2(); editSadvi() }} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Update</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        <FiAlertTriangle style={{ color: "orangered" }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center align-items-center" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>Are you sure want to Delete ??</div>
                    <div className='d-flex justify-content-between mt-3'>
                        <div onClick={()=> {setSmShow(false);deleteMuni()}} className='d-flex justify-content-center align-items-center p-1 rounded-1 me-2' style={{ width: '100%', backgroundColor: "#239B56", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Yes</div>
                        <div onClick={()=> setSmShow(false)} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#E74C3C", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>No</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
